import React, { useEffect } from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { getHomePageSettings } from './api/ecDataQueryApi';
import { useECSettingsContext } from './contexts/ecSettings';
import GuardedRoute from '../preorder/containers/GuardedRoute';
import useAuth from '../preorder/hooks/useAuth';
import { useProgressContext } from '../preorder/contexts/useProgressContext';
import Home from './components/home';
import Cart from './components/cart';
import Checkout from './components/checkout';
import Receipt from './components/receipt';
import Search from './components/search';
import Product from './components/product';
import LinePayPayment from '../preorder/containers/CheckoutPage/components/LinePayPayment';
import TapPay3DPayment from './components/checkout/TapPay3DPayment';

export default () => {
  const [checkAuthenticated] = useAuth();
  const { start: startProgress, end: endProgress } = useProgressContext();

  const { ecSettings, setECSettings } = useECSettingsContext();
  useEffect(() => {
    if (ecSettings) return;
    (async () => {
      startProgress();
      try {
        const data = (await getHomePageSettings()) || [];
        const newECSettings = {};
        data.forEach((setting) => {
          const {
            key,
            value,
          } = setting;
          try {
            const jsonValue = JSON.parse(value);
            newECSettings[key] = jsonValue;
          } catch (error) {
            console.error(error);
            newECSettings[key] = value;
          }
        });
        setECSettings(newECSettings);
      } catch (error) {
        console.error(error);
        setECSettings({});
      }
      endProgress();
    })();
  }, [ecSettings, setECSettings, startProgress, endProgress]);

  return (
    <div className="body-content">
      <Switch>
        <Route path="/ec/checkout/tap-pay-3d-payment" component={TapPay3DPayment} />
        <Route path="/ec/checkout/line-pay-payment" component={LinePayPayment} />
        <GuardedRoute
          path="/ec/checkout/receipt"
          checkAuthenticated={checkAuthenticated}
          redirectPath="/register"
          component={Receipt}
        />
        <GuardedRoute
          path="/ec/checkout"
          checkAuthenticated={checkAuthenticated}
          redirectPath="/register"
          component={Checkout}
        />
        <Route path="/ec/product/:productId" component={Product} />
        <Route path="/ec/search/:provider" component={Search} />
        <Route path="/ec/search" component={Search} />
        <Route path="/ec/cart" component={Cart} />
        <Route path="/ec" component={Home} />
      </Switch>
    </div>
  );
};
